import { SignInAutoPayload } from '@core/dto';
import { AuthModel } from '@core/models';
import { AuthAdapter } from '@core/adapters';

export class SignInAutoUseCase {
  constructor(private readonly authAdapter: AuthAdapter) {}
  async execute(payload: SignInAutoPayload): Promise<AuthModel> {
    return await this.authAdapter.autoSignIn(payload);
  }
}
